import Vue from 'vue';
import { handleMdfUpdatesToItem } from '@mimir/common/mdf/update';
import type { LoadedItem } from '@mimir/common/dto/searchResultHit';
import type { VueDeleteValue, VueSetValue } from '@mimir/common/util/general';
import type { SearchPlayerModuleState, UpdateCurrentPreviewItemPayload } from './search-player-module-state';


export function updateCurrentPreviewItemMutation(state: SearchPlayerModuleState, payload: UpdateCurrentPreviewItemPayload) {
  const currentItem = state.currentItem;
  if (!currentItem || payload.id !== currentItem.id) return;

  /*
    `payload.retrievedFields` contains a list of keys fetched from the server.
    Since `undefined` values are not transmitted over the API, we combine the
    fetched keys with those available in the `payload.update` object.

    This ensures that the client state is updated with the most recent data
    while correctly handling stale state updates.
  */
  const uniqueKeys = new Set([...Object.keys(payload.update), ...(payload.retrievedFields ?? [])]);
  const keysToIterateOver = Array.from(uniqueKeys) as (keyof LoadedItem)[];

  const vueSet = (v: VueSetValue) => Vue.set(v.object, v.key, v.value);
  const vueDeleter = (v: VueDeleteValue) => Vue.delete(v.object, v.key);
  for (const prop of keysToIterateOver) {
    if (prop === 'metadata' && payload.update.metadata !== undefined) {
      let metadataVersion = payload.update.metadataVersion;
      if (metadataVersion == undefined) {
        console.warn('updateCurrentPreviewItemMutation: metadata update without metadataVersion');
        metadataVersion = 0;
      }
      handleMdfUpdatesToItem(currentItem, payload.update.metadata, metadataVersion, vueSet, vueDeleter);
    } else if (payload.update[prop] === undefined) {
      Vue.delete(currentItem, prop);
    } else {
      Vue.set(currentItem, prop, payload.update[prop]);
    }
  }
}
